import { Reveal, Chapter } from "@/components/lunar/Reveal";

const STEPS = [
    {
        number: "01",
        title: "Scan",
        copy: "Attendees scan your event QR and say who they’d like to meet.",
    },
    {
        number: "02",
        title: "Spot",
        copy: "Lunar highlights relevant people already in the room.",
    },
    {
        number: "03",
        title: "Meet",
        copy: "If both agree, they get ten messages to find each other.",
    },
];

export const EventsHow = () => (
    <section id="events-how" className="mx-auto max-w-6xl scroll-mt-8 px-6 py-24 sm:py-28" data-testid="events-how-section">
        <Reveal>
            <Chapter index="01" label="How it works" />
            <h2 className="font-display mt-5 max-w-2xl text-4xl font-medium leading-[1.1] tracking-tight text-[#1D201A] sm:text-5xl">
                From arrival to introduction, in three steps.
            </h2>
        </Reveal>
        <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-8">
            {STEPS.map((step, i) => (
                <Reveal key={step.number} delay={i * 0.12} data-testid={`events-step-${i + 1}`}>
                    <div className="border-t border-[#C2C0B8] pt-7">
                        <span className="font-display text-5xl font-medium leading-none text-[#899B6A]">
                            {step.number}
                        </span>
                        <h3 className="font-display mt-5 text-2xl font-semibold uppercase tracking-wide text-[#1D201A]">
                            {step.title}
                        </h3>
                        <p className="mt-2 max-w-xs text-base leading-relaxed text-[#5C5F58]">
                            {step.copy}
                        </p>
                    </div>
                </Reveal>
            ))}
        </div>
        <Reveal delay={0.15}>
            <p
                data-testid="events-how-keyline"
                className="font-display mt-16 text-center text-2xl font-medium italic text-[#4A5D23] sm:text-3xl"
            >
                The phone has done its job.
            </p>
        </Reveal>
    </section>
);
